import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import LoginPage from "@/pages/Login";
import { useAuthStore } from "@/store/auth";

// Three.js (961KB) 가 포함된 Command·Dashboard 만 lazy — Missions·Alerts 는 즉시 로드
const CommandPage = lazy(() => import("@/pages/Command"));
const DashboardPage = lazy(() => import("@/pages/Dashboard"));
const MissionsPage = lazy(() => import("@/pages/Missions"));
const AlertsPage = lazy(() => import("@/pages/Alerts"));
const COPPage = lazy(() => import("@/pages/COP"));
const ReplayPage = lazy(() => import("@/pages/Replay"));
const Settings2FAPage = lazy(() => import("@/pages/Settings2FA"));
const RobotDetailPage = lazy(() => import("@/pages/RobotDetail"));
const RobotsPage = lazy(() => import("@/pages/Robots"));
const AuditPage = lazy(() => import("@/pages/Audit"));

function RequireAuth({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.accessToken);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function PageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 dark:bg-zinc-950">
      <div className="text-zinc-600 dark:text-zinc-400 text-sm">로딩 중…</div>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* 로그인 후 기본 랜딩 = Command View (관제 단일화면, 지침 §1) —
            기존 Dashboard 는 /dashboard 로 이동 */}
        <Route path="/" element={<RequireAuth><CommandPage /></RequireAuth>} />
        <Route path="/command" element={<RequireAuth><CommandPage /></RequireAuth>} />
        <Route path="/dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
        <Route path="/cop" element={<RequireAuth><COPPage /></RequireAuth>} />
        <Route path="/missions" element={<RequireAuth><MissionsPage /></RequireAuth>} />
        <Route path="/replay/:missionId" element={<RequireAuth><ReplayPage /></RequireAuth>} />
        <Route path="/alerts" element={<RequireAuth><AlertsPage /></RequireAuth>} />
        <Route path="/settings/2fa" element={<RequireAuth><Settings2FAPage /></RequireAuth>} />
        <Route path="/robots" element={<RequireAuth><RobotsPage /></RequireAuth>} />
        <Route path="/robots/:robotId" element={<RequireAuth><RobotDetailPage /></RequireAuth>} />
        <Route path="/audit" element={<RequireAuth><AuditPage /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
